import * as React from 'react';
import {Tooltip} from 'antd';
import {WarningOutlined} from '@ant-design/icons';

interface DangerIconProps {
  message: string;
}

export const DangerIcon = ({message}: DangerIconProps) => (
  <Tooltip title={message}>
    <WarningOutlined style={{color: '#f8292e', cursor: 'pointer'}} type="warning" />
  </Tooltip>
);
